import { Component } from '@angular/core';
import { NavParams, ModalController } from 'ionic-angular';

// Serviços
import { AlertService } from '../../providers/alert-service';
import { GestaoPcaService } from '../../providers/gestao-pca-service';
import { UsuarioService } from '../../providers/usuario-service';

//Paginas
import { ModalOcorrenciaPage } from '../modais/modal-ocorrencia/modal-ocorrencia';
import { ModalVincularArquivoPage } from '../modais/modal-vincular-arquivo/modal-vincular-arquivo';

/*
  Generated class for the ModulosController.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-modal-ocorrencia',
  templateUrl: 'modulos-controller.html'
})
export class ModulosController {
  usuario: any;
  PCAAtiva: any;
  moduloId: any;
  idModuloPca: any;
  isJurisdicionado: any;
  isCGE: boolean;

  constructor(public modalCtrl: ModalController, public navParams: NavParams, public alertService: AlertService, public usuarioService: UsuarioService, public gestaoPcaService: GestaoPcaService) {
    this.PCAAtiva = this.gestaoPcaService.getPCA();
    this.usuario = this.usuarioService.obtemUsuario();

    const result = this.usuarioService.getGrupoJurisdicionado().indexOf(this.usuarioService.obterDadosUsuario().perfil.replace("(","").replace(")","")) != -1;

    // this.isJurisdicionado = this.usuarioService.isJurisdicionado();
    this.isJurisdicionado = result;
    this.isCGE = this.usuarioService.isCGE();

    usuarioService.getUsuario().subscribe(broadcastVariable => {
      this.usuario = broadcastVariable.usr;
      // this.isJurisdicionado = this.usuarioService.isJurisdicionado();
      this.isJurisdicionado = result;
      this.isCGE = this.usuarioService.isCGE();
      this.carregarModulo();
    });

    // console.log(this.isJurisdicionado);
  }

  setModuloId(idModulo) {
    this.moduloId = idModulo;
  }

  getIdModulo() {
    return this.moduloId;
  }

  setIdModuloPca(idModuloPca) {
    this.idModuloPca = idModuloPca;
  }

  getIdModuloPca() {
    return this.idModuloPca;
  }

  carregarModulo() {

  }

  /*================================================================
  *
  *  Métodos Visualização e Edição de Evidencias
  *
  ==================================================================*/

  visualizarTelaEvidencias(recebeTitulo: string, recebeObjeto: any, recebeServico: any, recebeTiposArquivos: string): any {
    let modal = this.modalCtrl.create(ModalVincularArquivoPage, {
      titulo: recebeTitulo,
      objeto: recebeObjeto,
      jurisdicionado: this.isJurisdicionado,
      servico: recebeServico,
      tiposaceitos: recebeTiposArquivos
    });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal == 200) {
        return 200;
      }
    });
    modal.present();
  }

  /*================================================================
  *
  *  Métodos Ocorrência
  *
  ==================================================================*/
  visualizarOcorrencias() {
    let idModulo = this.getIdModulo();
    let idModuloPca = this.getIdModuloPca();
    let idPCA = this.gestaoPcaService.getPCA().id;
    let analise = this.navParams.get('analise');

    let modal = this.modalCtrl.create(ModalOcorrenciaPage, { flag: "visualizar", idmodulo: idModulo, idModuloPca: idModuloPca, idpca: idPCA, analise: analise });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal) {
      }
    });
    modal.present();
  }

  cadastrarOcorrencia() {
    let idModulo = this.getIdModulo();
    let idModuloPca = this.getIdModuloPca();
    let idPCA = this.gestaoPcaService.getPCA().id;
    let analise = this.navParams.get('analise');

    let modal = this.modalCtrl.create(ModalOcorrenciaPage, { idmodulo: idModulo, idModuloPca: idModuloPca, idpca: idPCA, analise: analise });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal) {
      }
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/modulos-controller.ts